export enum Events {
  AnalyticsReset = 'analytics_reset',
  AnalyticsUserReady = 'analytics_user_ready',
  SwipeMapOpened = 'swipe_map_opened',
  SwipeMapIterationSelectedLeftPane = 'swipe_map_iteration_selected_left_pane',
  SwipeMapIterationSelectedRightPane = 'swipe_map_iteration_selected_right_pane',
  AddLayerButtonClicked = 'add_layer_button_clicked',
  CreateLayerButtonClicked = 'create_layer_button_clicked',
  CreateLayerModalOpened = 'create_layer_modal_opened',
  OpenGraphViewerClicked = 'open_graph_viewer_clicked',
  GenerateProfileClicked = 'generate_profile_clicked',
  DownloadPdfClicked = 'download_pdf_clicked',
  CalculateButtonClicked = 'calculate_button_clicked',
  ExportPdfClicked = 'export_pdf_clicked',
  SessionStarted = 'session_started',
  WorkspaceViewLoaded = 'workspace_view_loaded',
  GenerateCleanupClicked = 'generate_cleanup_clicked',
  FileDownloaded = 'file_downloaded',
  MergedDatasetOutputPublished = 'merged_dataset_output_published',
  ContourGenerationCompleted = 'contour_generation_completed',
}

export enum EventPropertyKey {
  IterationName = 'iteration_name',
  ProjectName = 'project_name',
  LayerName = 'layer_name',
  LayerType = 'layer_type',
  AccessTags = 'access_tags',
  SiteName = 'site_name',
  DownloadFormat = 'download_format',
  HeapClusterName = 'heap_cluster_name',
  HeapClusterCategory = 'heap_cluster_category',
  HeapClusterMaterial = 'heap_cluster_material',
  BulkDensity = 'bulk_density',
  ExportFormat = 'export_format',
  UserId = 'user_id',
  OrganizationName = 'organization_name',
  EmailId = 'email_id',
  CleanupName = 'cleanup_name',
  AreaOfInterestType = 'area_of_interest_type',
  PolygonCount = 'polygon_count',
  FileFormat = 'file_format',
  OutputType = 'output_type',
  MergedDatasetName = 'merged_dataset_name',
  Status = 'status',
  FailureReason = 'failure_reason',
}

export type EventProperties = Partial<Record<EventPropertyKey, unknown>>;

export enum EventStatus {
  Success = 'success',
  Failure = 'failure',
}
